import PropTypes from "prop-types";
import moment from "moment";
import "moment/locale/tr";

const Datef = ({ value, format }) => <span>{moment.utc(value).format(format)}</span>;

Datef.propTypes = {
  value: PropTypes.string,
  format: PropTypes.string,
};
export default Datef;
